import { render, staticRenderFns } from "./StatusBankCard.vue?vue&type=template&id=01d4b098&"
import script from "./StatusBankCard.vue?vue&type=script&lang=ts&"
export * from "./StatusBankCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports